<template>
  <div class="grid justify-items-center" id="app">
    <form method="POST" @submit.prevent="gestioneLogin" class="form-login">
      <input type="hidden" :value="csrfToken" name="_token" />
      <div class="login-form">
        <InputText id="email" name="email" type="email" class="form-control text-disabilitato"
                   v-model="email" required autocomplete="email" :style="fieldErrors.email || errorMessage ? 'border: 3px solid #CA2124 !important;' : ''"
                   autofocus placeholder="e-mail" />
        <small v-if="fieldErrors.email" class="text-error-login text-sm mt-1">
          {{ fieldErrors.email }}
        </small>
      </div>
      <div class="login-form">
        <Password id="password" name="password" toggleMask class="form-control text-disabilitato" :feedback="false"
                  v-model="password" required placeholder="password" :style="fieldErrors.password || errorMessage ? 'border: 2px solid #CA2124 !important;' : ''"/>
        <small v-if="fieldErrors.password" class="text-error-login text-sm mt-1">
          {{ fieldErrors.password }}
        </small>
      </div>

      <small v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </small>

      <div class="bottone-login pt-8">
        <Button :label="labelLogin" class="background-paragrafo-secondario" type="submit" />
      </div>

      <div class="card-oppure pt-8" v-if="googleLogin || microsoftLogin">
        <div class="flex items-center">
          <div class="flex-grow h-px bg-white"></div>
          <p class="text-white px-[15px] small-maiuscoletto">{{ labelOppure }}</p>
          <div class="flex-grow h-px bg-white"></div>
        </div>
      </div>

      <div class="button-container flex gap-[20px]">
        <div >
          <a href="https://devx.app-alto.it/auth/google/redirect" v-if="googleLogin">
            <img src="bottone_login_google.svg">
          </a>
        </div>
        <div>
          <a href="https://devx.app-alto.it/auth/microsoft/redirect" v-if="microsoftLogin">
            <img src="bottone_login_microsoft.svg">
          </a>
        </div>
      </div>


    </form>
  </div>
</template>

<script>
import axios from 'axios';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';


export default {
  props: {
    labelOppure: String,
    labelLogin: String,
    googleLogin: Boolean,
    microsoftLogin: Boolean
  },

  components: {
    InputText,
    Password,
    Button
  },
  data() {
    return {
      email: '',
      password: '',
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      errorMessage: '',
      fieldErrors: {
        email: '',
        password: ''
      }
    };
  },
  methods: {
    async gestioneLogin() {
      this.errorMessage = '';
      this.fieldErrors = { email: '', password: '' };

      let hasError = false;

      if (!this.email) {
        this.fieldErrors.email = 'Inserisci la tua e-mail';
        hasError = true;
      } else if (!this.validateEmail(this.email)) {
        this.fieldErrors.email = 'Formato e-mail non valido';
        hasError = true;
      }

      if (!this.password) {
        this.fieldErrors.password = 'Inserisci la password';
        hasError = true;
      }

      if (hasError) return;

      try {
        const response = await axios.post('/login/accesso', {
          email: this.email,
          password: this.password,
          _token: this.csrfToken
        });

        if (response.data.success) {
          if (response.data.url) {
            window.location.href = response.data.url;
          } else if (response.data.redirect) {
            window.location.href = route(response.data.redirect, response.data.params);
          } else {
            window.location.href = '/dashboard';
          }
        } else {
          this.errorMessage = trans('credenziali_errate');
        }

      } catch (error) {
        if (error.response && error.response.status === 422) {
          // Validazione lato server
          const serverErrors = error.response.data.errors;
          if (serverErrors.email) {
            this.fieldErrors.email = serverErrors.email[0];
          }
          if (serverErrors.password) {
            this.fieldErrors.password = serverErrors.password[0];
          }
        } else if (error.response && error.response.status === 401) {
          this.errorMessage = trans('credenziali_errate');
        } else {
          this.errorMessage = trans('errore_generico');
        }
      }
    },
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    }
  }

}
</script>

<style scoped>

</style>
